import { render, staticRenderFns } from "./project-download-actions.vue?vue&type=template&id=1d72c789&"
import script from "./project-download-actions.vue?vue&type=script&lang=js&"
export * from "./project-download-actions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports